module.exports = ".additional-tbl{ min-width: 200px !important;}\r\n"